<template>
    <template v-if="url">
        <video width="100%" controls v-if="isVideo" style="border-radius: 15px; border: 1px solid #f5f5f5">
            <source :src="url" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <audio style="width: 100%" controls :src="url" v-else/>
    </template>

    <p v-else>
        <a-space>
            <a>
                <template v-if="isVideo">
                    <VideoCameraOutlined class="big-icon" v-if="status === 2"/>
                    <VideoCameraAddOutlined class="big-icon" v-else/>
                </template>
                <template v-else>
                    <AudioOutlined class="big-icon" v-if="status === 2"/>
                    <AudioMutedOutlined  class="big-icon" v-else/>
                </template>
            </a>
            <span>
                {{progress < 5? 'AI'+cn+'正在生成中，预计需要5分钟...': '无'}}
            </span>
        </a-space>
    </p>
</template>

<script>
    import {
        AudioMutedOutlined, AudioOutlined,
        VideoCameraOutlined, VideoCameraAddOutlined
    } from '@ant-design/icons-vue';

    export default {
        name: "PubmedMedia",
        props: ['media', 'paperNo', 'status', 'url', 'progress', 'cn'],
        components: {
            AudioMutedOutlined, AudioOutlined,
            VideoCameraOutlined, VideoCameraAddOutlined,
        },
        data(){
            return {
                isVideo: this.media === 'video',
                loading: false,
                paper_no: Number(this.paperNo),
                media_data: '',
            }
        },
        mounted(){
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>
